/**
 * @generated SignedSource<<892e56f562c70f0a6f3d1d0f2caf426c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistSubmissionStatus_enum = "Approved" | "ApprovedWithoutVoting" | "Pending" | "Rejected" | "VoteActive" | "%future added value";
export type SafetyCheckPageQuery$variables = {
  id: string;
};
export type SafetyCheckPageQuery$data = {
  readonly User_by_pk: {
    readonly ArtistSubmissions: ReadonlyArray<{
      readonly Votes: ReadonlyArray<{
        readonly id: string;
        readonly timeCreated: string;
      }>;
      readonly id: string;
      readonly status: ArtistSubmissionStatus_enum | null;
    }>;
    readonly id: string;
    readonly isWhitelisted: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"SafetyCheckForm_User">;
  } | null;
};
export type SafetyCheckPageQuery = {
  response: SafetyCheckPageQuery$data;
  variables: SafetyCheckPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isWhitelisted",
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "order_by",
  "value": {
    "timeCreated": "desc"
  }
},
v5 = {
  "alias": null,
  "args": [
    (v4/*: any*/)
  ],
  "concreteType": "ArtistSubmission",
  "kind": "LinkedField",
  "name": "ArtistSubmissions",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        },
        (v4/*: any*/),
        {
          "kind": "Literal",
          "name": "where",
          "value": {
            "voteType": {
              "_in": [
                "PrescreenReject",
                "Reject"
              ]
            }
          }
        }
      ],
      "concreteType": "Vote",
      "kind": "LinkedField",
      "name": "Votes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeCreated",
          "storageKey": null
        }
      ],
      "storageKey": "Votes(limit:1,order_by:{\"timeCreated\":\"desc\"},where:{\"voteType\":{\"_in\":[\"PrescreenReject\",\"Reject\"]}})"
    }
  ],
  "storageKey": "ArtistSubmissions(order_by:{\"timeCreated\":\"desc\"})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SafetyCheckPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "User_by_pk",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SafetyCheckForm_User"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SafetyCheckPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "User_by_pk",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "twitterName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DiscordAuth",
            "kind": "LinkedField",
            "name": "DiscordAuth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasConnectedDiscordAccount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasJoinedDiscordServer",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "discordHandle",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "instagramName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d44107fb90d45cba6799bbef47ce8da3",
    "id": null,
    "metadata": {},
    "name": "SafetyCheckPageQuery",
    "operationKind": "query",
    "text": "query SafetyCheckPageQuery(\n  $id: String!\n) {\n  User_by_pk(id: $id) {\n    id\n    isWhitelisted\n    ArtistSubmissions(order_by: {timeCreated: desc}) {\n      id\n      status\n      Votes(where: {voteType: {_in: [PrescreenReject, Reject]}}, order_by: {timeCreated: desc}, limit: 1) {\n        id\n        timeCreated\n      }\n    }\n    ...SafetyCheckForm_User\n  }\n}\n\nfragment ConnectDiscordButton_User on User {\n  id\n  DiscordAuth {\n    discordHandle\n  }\n  ...ConnectSocialNetworkButton_User\n}\n\nfragment ConnectInstagramButton_User on User {\n  id\n  instagramName\n  ...ConnectSocialNetworkButton_User\n}\n\nfragment ConnectSocialNetworkButton_User on User {\n  id\n  DiscordAuth {\n    hasConnectedDiscordAccount\n  }\n}\n\nfragment ConnectTwitterButton_User on User {\n  id\n  twitterName\n  ...ConnectSocialNetworkButton_User\n}\n\nfragment DiscordAuthConnectModal_User on User {\n  id\n  isWhitelisted\n  DiscordAuth {\n    id\n    hasConnectedDiscordAccount\n    hasJoinedDiscordServer\n  }\n}\n\nfragment DiscordAuthDisconnectModal_User on User {\n  id\n}\n\nfragment DiscordAuthModals_User on User {\n  ...DiscordAuthConnectModal_User\n  ...DiscordAuthDisconnectModal_User\n}\n\nfragment SafetyCheckForm_User on User {\n  id\n  twitterName\n  DiscordAuth {\n    hasConnectedDiscordAccount\n    hasJoinedDiscordServer\n  }\n  ...ConnectDiscordButton_User\n  ...ConnectInstagramButton_User\n  ...ConnectTwitterButton_User\n  ...DiscordAuthModals_User\n}\n"
  }
};
})();

(node as any).hash = "b2002662164c01f821bab084a819e9b8";

export default node;
